import React from 'react';
import { createContext, useContext, useMemo } from 'react';

export const StickyNavBarOffsetContext = createContext<{
  offset: number;
}>({
  offset: 0,
});

interface StickyNavBarOffsetProviderProps
  extends Readonly<{
    changesReminderBanner: boolean;
    unpublishedWebsiteBanner: boolean;
  }> {}

const CHANGES_REMINDER_BANNER_HEIGHT = 56;
const UNPUBLISHED_WEBSITE_BANNER_HEIGHT = 80;

export const StickyNavBarOffsetProvider: React.FC<StickyNavBarOffsetProviderProps> = ({ children, changesReminderBanner, unpublishedWebsiteBanner }) => {
  const offset = useMemo(() => {
    let offset = 0;

    if (changesReminderBanner) {
      offset += CHANGES_REMINDER_BANNER_HEIGHT;
    }

    if (unpublishedWebsiteBanner) {
      offset += UNPUBLISHED_WEBSITE_BANNER_HEIGHT;
    }

    return offset;
  }, [changesReminderBanner, unpublishedWebsiteBanner]);

  return <StickyNavBarOffsetContext.Provider value={{ offset }}>{children}</StickyNavBarOffsetContext.Provider>;
};

export const useStickyNavBarOffset = () => {
  return useContext(StickyNavBarOffsetContext);
};
